import React from 'react';
import { Text } from '@fragments';
import { IconFlame } from '@tabler/icons-react';
import './styles.scss';

// ApiDog StudioTopic.relevance_score is editorial relevance on a 0–1 scale.
// Keep absent/invalid values absent instead of inventing a popularity score.
export default function TopicScore({ topic, t }) {
  const score = topic.relevance_score;
  if (!Number.isFinite(score) || score < 0 || score > 1) return null;
  const value = Math.round(score * 100);
  return <Text.span className="studio-topic-score" aria-label={t('topicRelevance', { score: value })}>
    <IconFlame aria-hidden="true" /><Text.span aria-hidden="true">{value}</Text.span>
  </Text.span>;
}
